import { render, staticRenderFns } from "./AsideSitecore.vue?vue&type=template&id=46f33f72"
import script from "./AsideSitecore.vue?vue&type=script&lang=js"
export * from "./AsideSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports